import { render, staticRenderFns } from "./CustomerReturnDetails.vue?vue&type=template&id=63718dfe&scoped=true"
import script from "./CustomerReturnDetails.vue?vue&type=script&lang=js"
export * from "./CustomerReturnDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerReturnDetails.vue?vue&type=style&index=0&id=63718dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63718dfe",
  null
  
)

export default component.exports